import request from '@/common/request'
import { AxiosRequestConfig } from 'axios'
import { Page } from '@/models/Page'
import {
	EstadoDasIntegracoes,
	ItemDoPainelDeIntegracao,
	ItemReenviado,
	OperacaoDoItemDeIntegracao,
	SituacaoDoItemDeIntegracao,
	TipoDoItemDeIntegracao,
} from '@/models/ItemDoPainelDeIntegracao'

const basePath = '/painel-de-integracao'

export interface FiltroDeItensDoPainelDeIntegracao {
	tipo?: TipoDoItemDeIntegracao[]
	operacao?: OperacaoDoItemDeIntegracao[]
	situacao?: SituacaoDoItemDeIntegracao[]
	dataInicial?: string
	dataFinal?: string
	busca?: string
	page: number
	size: number
	sort: string[]
}

export const listarItens = async (
	filtro: FiltroDeItensDoPainelDeIntegracao,
	config?: AxiosRequestConfig,
): Promise<Page<ItemDoPainelDeIntegracao>> =>
	request.get(`${basePath}/itens`, { params: filtro, ...config })

export const buscarComando = async (
	itemId: string,
	config?: AxiosRequestConfig,
): Promise<{ comando: string }> =>
	request.get(`${basePath}/itens/${itemId}/comando`, { ...config })

export const buscarEstadoDasIntegracoes = async (
	config?: AxiosRequestConfig,
): Promise<EstadoDasIntegracoes> =>
	request.get(`${basePath}/integracoes`, { ...config })

export const reenviar = async (
	itensIds: string[],
	config?: AxiosRequestConfig,
): Promise<{ reenviados: ItemReenviado[] }> =>
	request.post(`${basePath}/reenvios`, { itensIds }, { ...config })
